<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Inter" />

<div id="app-header-container" class="flex-shrink-0">
  <fdk-header
    [logoUrl]="logoUrl || null"
    [logoAlt]="companyName"
    [name]="companyName"
    [testMode]="
      (configService.systemConfigSubject | async)?.apiMode === testApiMode
    "
    [showBackButton]="shouldShowHeaderBackButton()"
    [showReportIssueButton]="!!headerConfig.showReportIssueButton"
    [showProfileButton]="
      !!headerConfig.showProfileButton &&
      !!(configService.vaultProfileConfigSubject | async)
        ?.verifiedIdentityPatientDemographics
    "
    [showCloseButton]="true"
    (back)="handleHeaderBack()"
    (reportIssue)="handleHeaderReportIssue()"
    (profile)="handleHeaderProfile()"
    (close)="handleHeaderClose()"
  >
    <fdk-logo />
  </fdk-header>
</div>

<fdk-dialog
  [open]="closeConfirmationOpen"
  (openChange)="closeConfirmationOpen = $event"
>
  <fdk-dialog-title>Stop connecting your records?</fdk-dialog-title>
  <fdk-dialog-content>
    If you close now, your progress won't be saved and you'll need to start again.
  </fdk-dialog-content>
  <fdk-dialog-actions>
    <fdk-button
      type="button"
      variant="secondary"
      (click)="cancelHeaderClose()"
    >
      Cancel
    </fdk-button>
    <fdk-button type="button" (click)="confirmHeaderClose()">
      Close
    </fdk-button>
  </fdk-dialog-actions>
</fdk-dialog>

<ng-container *ngIf="loading || !errorMessage">
  <div id="widget-container" class="px-6 pb-6 fade-in flex flex-col">
    <main id="page-scroll-container">
      <ng-container *ngIf="loading; else loadedPage">
        <app-health-system-search-skeleton *ngIf="searchOnly; else welcomeSkeleton" />
        <ng-template #welcomeSkeleton>
          <app-welcome-skeleton />
        </ng-template>
      </ng-container>
      <ng-template #loadedPage>
        <router-outlet></router-outlet>
      </ng-template>
    </main>
    <fdk-footer></fdk-footer>
  </div>
</ng-container>

<ng-container *ngIf="!loading && errorMessage">
  <div id="error-container" class="w-full p-6 min-h-96">
    <div class="relative p-4 w-full max-w-2xl h-full md:h-auto">
      <div
        id="alert-additional-content-2"
        class="p-4 border border-red-300 rounded-lg bg-[#DC3545] text-white"
        role="alert"
      >
        <div class="flex items-center">
          <svg
            class="flex-shrink-0 w-4 h-4 me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z"
              clip-rule="evenodd"
            />
          </svg>

          <span class="sr-only">Error</span>
          <h3 class="text-lg font-medium">Configuration Error</h3>
        </div>
        <div class="mt-2 mb-4 text-sm">
          {{ errorMessage }}
        </div>
        <div class="flex">
          <button
            (click)="modalClose()"
            type="button"
            class="text-white bg-transparent border border-white hover:bg-red-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-grey-300 font-medium rounded-lg text-xs px-3 py-1.5 text-center"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
